module.exports = __webpack_public_path__ + "img/IMG_4639-min.a35cfe0b.jpg";